<script>
  import Layout from "../Layout/Layout.svelte";
  import config from "../stores/config";
  import axios from "axios";
  import { onMount } from "svelte";
  import { Circle } from "svelte-loading-spinners";
  import Container from "../shared/Container.svelte";
  import SectionHeading from "../shared/SectionHeading.svelte";
  import * as animateScroll from "svelte-scrollto";
  import * as ls from "local-storage";
  import t from "../utils/t";

  let loading = true;
  let profile = null;
  let uploading = false;
  let uploadingPwd = false;
  let currentPassword;
  let newPassword;
  let confirmNewPassword;

  const loadSettings = () => {
    axios
      .get(`${$config.backendURL}/me`, {
        headers: { authorization: ls.get("jwt") },
      })
      .then((res) => {
        profile = res.data;
        loading = false;
      })
      .catch((err) => {
        loading = false;
        console.log(err);
      });
  };

  const handleSubmit = () => {
    uploading = true;
    axios
      .put(
        `${$config.backendURL}/users/${profile._id}`,
        { ...profile },
        { headers: { authorization: ls.get("jwt") } }
      )
      .then((res) => {
        alert("✅ Done Successfully!");
        console.log(res);
        uploading = false;
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        uploading = false;
      });
  };

  const handleSubmitNewPwd = () => {
    if (newPassword != confirmNewPassword) {
      alert(
        t({
          en: "New password & Confirm Password Don't match",
          fr: "Le nouveau mot de passe et le mot de passe confirmé ne sont pas identiques",
        })
      );
      return;
    }
    uploadingPwd = true;
    axios
      .put(
        `${$config.backendURL}/users/password/${profile._id}`,
        { currentPassword, newPassword },
        { headers: { authorization: ls.get("jwt") } }
      )
      .then((res) => {
        alert("✅ Done Successfully!");
        console.log(res);
        uploadingPwd = false;
        window.location.reload();
      })
      .catch((err) => {
        console.log(err);
        uploadingPwd = false;
        alert("Make sure your current password was entered correctly!");
      });
  };

  onMount(() => {
    animateScroll.scrollToTop();
    loadSettings();
  });
</script>

<svelte:head>
  <title>Votre Profile | SAMAKI EXPRESS</title>
</svelte:head>

<Layout>
  <Container>
    <SectionHeading
      text1={t({
        en: "Votre Profile",
        fr: "Votre Profil",
      })}
    />
    {#if loading}
      <div class="h-52 w-full flex items-center justify-center">
        <Circle size="50" color="rgb(16, 185, 129)" unit="px" />
      </div>
    {:else}
      <form
        on:submit|preventDefault={handleSubmit}
        class="grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
      >
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-2 items-center">
            <div>{t({ en: "Full Name", fr: "Nom Complet" })}:</div>
            <input
              class="lg:col-span-2 shadow-sm placeholder-gray-300"
              type="text"
              bind:value={profile.name}
              placeholder={t({ en: "Full Name", fr: "Nom Complet" })}
              required
            />
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-2 items-center">
            <div>Telephone:</div>
            <input
              class="lg:col-span-2 shadow-sm placeholder-gray-300"
              type="text"
              bind:value={profile.tel}
              placeholder="Telephone"
              required
            />
          </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <!-- <div class="grid grid-cols-1 lg:grid-cols-3 gap-2 items-center">
            <div>Email:</div>
            <input
              class="lg:col-span-2 shadow-sm placeholder-gray-300"
              type="text"
              bind:value={profile.email}
              placeholder="Email"
              required
              readonly
            />
          </div> -->
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-2 items-center">
            <div>Nom d'utilisateur (Non Modifiable):</div>
            <input
              class="lg:col-span-2 shadow-sm placeholder-gray-300"
              type="text"
              bind:value={profile.username}
              placeholder={t({ en: "Username", fr: "Nom d'utilisateur" })}
              required
              readonly
              disabled
            />
          </div>
        </div>

        {#if uploading}
          <div class="grid grid-cols-1 gap-8">
            <div
              class="flex items-center justify-center btn btn-primary"
              style="width: 100%;"
            >
              <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
              <span class="ml-4"
                >{t({
                  en: "Saving, Please Wait",
                  fr: "Veuillez Patienter...",
                })}</span
              >
            </div>
          </div>
        {:else}
          <button class="btn btn-primary" style="width: 100%;">
            <ion-icon name="checkmark-circle" class="mr-2 text-2xl" />
            {t({
              en: "Save Changes",
              fr: "Sauvegarder",
            })}
          </button>
        {/if}
      </form>

      <!-- Change Password -->
      <!-- Change Password -->
      <!-- Change Password -->

      <h1 class="mt-12 text-gray-500 text-xl uppercase">
        {t({
          en: "CHANGE YOUR PASSWORD",
          fr: "CHANGER VOTRE MOT DE PASSE",
        })}:
      </h1>

      <form
        on:submit|preventDefault={handleSubmitNewPwd}
        class="mt-8 grid grid-cols-1 gap-y-4 text-gray-500 pb-8"
      >
        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-2 items-center">
            <div>
              {t({
                en: "Current Password",
                fr: "Mot de passe Actuel",
              })}:
            </div>
            <input
              class="lg:col-span-2 shadow-sm placeholder-gray-300"
              type="password"
              bind:value={currentPassword}
              placeholder={t({
                en: "Current Password",
                fr: "Mot de passe Actuel",
              })}
              required
            />
          </div>
        </div>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-2 items-center">
            <div>{t({ en: "New Password", fr: "Nouveau Mot de passe" })}:</div>
            <input
              class="lg:col-span-2 shadow-sm placeholder-gray-300"
              type="password"
              bind:value={newPassword}
              placeholder={t({
                en: "New Password",
                fr: "Nouveau Mot de passe",
              })}
              required
            />
          </div>
          <div class="grid grid-cols-1 lg:grid-cols-3 gap-2 items-center">
            <div>
              {t({ en: "Confirm Password", fr: "Confirmer Mot de passe" })}:
            </div>
            <input
              class="lg:col-span-2 shadow-sm placeholder-gray-300"
              type="password"
              bind:value={confirmNewPassword}
              placeholder={t({
                en: "Retype New Password",
                fr: "Re-entrez le nouveau passe",
              })}
              required
            />
          </div>
        </div>

        {#if uploadingPwd}
          <div class="grid grid-cols-1 gap-8">
            <div class="flex items-center justify-center btn btn-primary">
              <Circle size="25" color="rgb(16, 185, 129)" unit="px" />
              <span class="ml-4"
                >{t({
                  en: "Saving, Please Wait",
                  fr: "Veuillez Patienter...",
                })}</span
              >
            </div>
          </div>
        {:else}
          <button class="btn btn-primary" style="width: 100%;">
            <ion-icon name="checkmark-circle" class="mr-2 text-2xl" />
            {t({
              en: "Update Password",
              fr: "Sauvegarder",
            })}
          </button>
        {/if}
      </form>
    {/if}
  </Container>
</Layout>
